var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeparatorDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 13,
    fill: "none",
    viewBox: "0 0 27 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.1845
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.8238,
    cy: 6.5,
    rx: 3.5707,
    ry: 3.4717,
    fill: "#c000c0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.317,
    cy: 6.5,
    rx: 3.5707,
    ry: 3.4717,
    fill: "#00c0c0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.231,
    cy: 6.5,
    rx: 3.5707,
    ry: 3.4717,
    fill: "#d8c535"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeparatorDots);
export default __webpack_public_path__ + "static/media/separatorDots.30398660bf4b460defb1ebc50574145e.svg";
export { ForwardRef as ReactComponent };